import { css } from "styled-system/css";

export { pageContainerStyles as pageStyles, pageHeaderStyles as headerStyles } from "#/app.css";

export const titleStyles = css({
  fontFamily: "sans",
  fontWeight: "900",
  letterSpacing: "-0.025em",
  color: "textBase",
  fontSize: "h2",
});

export const sectionStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "md",
  paddingBottom: "lg",
});

export const sectionTitleStyles = css({
  fontSize: "xs",
  fontWeight: "900",
  textTransform: "uppercase",
  letterSpacing: "0.1em",
  color: "textBase/50",
  marginBottom: "sm",
  paddingInline: "0.25rem",
});

export const rowStyles = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingInline: "0.25rem",
  paddingY: "0.5rem",
});

export const settingRowGridStyles = css({
  display: "grid",
  gridTemplateColumns: "2.5rem 1fr auto",
  columnGap: "0.75rem",
  alignItems: "center",
  paddingInline: "0.25rem",
});

export const settingsContainerStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  paddingBottom: "2.5rem",
});

export const settingsGroupStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "1.5rem",
});

export const settingsItemStyles = css({
  display: "flex",
  flexDirection: "column",
  gap: "0.75rem",
});

export const settingHeaderStyles = css({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  fontWeight: "700",
  fontSize: "14px",
});

export const settingDescriptionStyles = css({
  fontSize: "12px",
  opacity: 0.6,
  fontWeight: "500",
  marginTop: "0.25rem",
  lineHeight: "1.4",
});

export const iconBoxStyles = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "2.5rem",
  height: "2.5rem",
  borderRadius: "medium",
  backgroundColor: "primary/10",
  color: "primary",
});

export const labelGroupStyles = css({
  display: "flex",
  flexDirection: "column",
});

export const labelTextStyles = css({
  fontSize: "sm",
  fontWeight: "900",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  color: "textBase/50",
});

export const valueTextStyles = css({
  fontSize: "xs",
  fontWeight: "700",
});

export const rowButtonStyles = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "0.75rem",
  width: "100%",
  paddingInline: "0.25rem",
  paddingY: "0.5rem",
  border: "none",
  background: "transparent",
  color: "inherit",
  fontFamily: "sans",
  textAlign: "left",
  cursor: "pointer",
  borderRadius: "medium",
  transitionProperty: "background-color",
  transitionDuration: "0.2s",
  _hover: {
    backgroundColor: "bgBase200",
  },
  _disabled: {
    cursor: "not-allowed",
    _hover: {
      backgroundColor: "transparent",
    },
  },
});

export const chevronStyles = css({
  color: "textMuted",
  flexShrink: 0,
});

export const logoutBtnStyles = css({
  cursor: "pointer",
  transition: "all 200ms",
  userSelect: "none",
  border: "none",
  outline: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingInline: "xl",
  paddingY: "sm",
  backgroundColor: "error",
  color: "#ffffff",
  borderRadius: "medium",
  fontWeight: "900",
  textTransform: "uppercase",
  width: "fit-content",
  _hover: {
    backgroundColor: "error/80",
  },
});

/* Form Elements */
export const selectStyles = css({
  width: "100%",
  padding: "sm",
  borderRadius: "medium",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  backgroundColor: "bgBase100",
  color: "inherit",
  outline: "none",
  fontSize: "sm",
});

export const successMessageStyles = css({
  backgroundColor: "color-mix(in srgb, {colors.success}, transparent 90%)",
  color: "success",
  padding: "sm",
  borderRadius: "medium",
  fontSize: "sm",
  fontWeight: 700,
  textAlign: "center",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "color-mix(in srgb, {colors.success}, transparent 80%)",
});

export const toggleStyles = css({
  cursor: "pointer",
  width: "3rem",
  height: "1.5rem",
  borderRadius: "full",
  backgroundColor: "bgBase300",
  position: "relative",
  transition: "background-color 0.2s",
});
